module.exports = __webpack_public_path__ + "static/media/money-white.93955039.png";